/**
 * ============================================================
 * Layer Import
 * MiningSurveyWebGIS
 * ============================================================
 */

import AppState from "../core/app.js";

import LayerManager from "./layers.js";
import UI from "./ui.js";

import KMLParser from "./kml/parser.js";
import KMLStyle from "./kml/style.js";
import Renderer from "./kml/renderer.js";

import { CADImport } from "./cad/cad-import.js";

class LayerImport {
    /* ========================================================
     * Open File
     * ========================================================
     */

    async open(file) {
        const ext = file.name.split(".").pop().toLowerCase();

        switch (ext) {
            case "kml":
                return await this.importKML(file);

            case "kmz":
                return await this.importKMZ(file);
            
            case "dxf":
                return await CADImport.open(file);

            default:
                throw new Error(`Format file tidak didukung : ${ext}`);
        }
    }
    /**
     * ========================================================
     * Import KML
     * ========================================================
     */

    async importKML(file) {
        try {
            //--------------------------------------------------
            // File Name
            //--------------------------------------------------

            const layerName = file.name.replace(/\.[^/.]+$/, "");

            //--------------------------------------------------
            // Read XML
            //--------------------------------------------------

            const text = await file.text();

            const xml = new DOMParser().parseFromString(text, "application/xml");

            //--------------------------------------------------
            // Parse
            //--------------------------------------------------

            const data = KMLParser.parse(xml);

            //--------------------------------------------------
            // Style
            //--------------------------------------------------

            const styles = KMLStyle.parse(xml);

            //--------------------------------------------------
            // Render
            //--------------------------------------------------

            const group = Renderer.render(data, styles);

            //--------------------------------------------------
            // Add to Map
            //--------------------------------------------------

            group.addTo(AppState.map);

            //--------------------------------------------------
            // Bounds
            //--------------------------------------------------

            const bounds = group.getBounds();

            //--------------------------------------------------
            // Layer Manager
            //--------------------------------------------------

            LayerManager.add(
                layerName,

                "kml",

                group,

                bounds,
            );

            //--------------------------------------------------
            // Zoom
            //--------------------------------------------------

            if (bounds.isValid()) {
                AppState.map.fitBounds(bounds);
            }

            //--------------------------------------------------
            // Refresh UI
            //--------------------------------------------------

            UI.renderLayerList();
        } catch (err) {
            console.error(err);

            alert("Gagal membuka file KML.");
        }
    }

    /**
     * ========================================================
     * KMZ
     * ========================================================
     */

    async importKMZ(file) {
        alert("KMZ belum diimplementasikan.");
    }
}

export default new LayerImport();
